import { determinePaginationParams, readUrl, determineSelector, getResource } from "./api";

const getAllByCompanyId = async (companyId, options = { page: 1, per_page: 10 }) => {
  const selector = determineSelector(companyId, { keyId: "company_id", keySlug: "company_slug" });
  const paginationParams = determinePaginationParams(options);
  const url = readUrl("company_representations", { selector, paginationParams });
  return getResource(url);
};

const getAllByPromotedCompanyId = async (companyId, options = { page: 1, per_page: 10 }) => {
  const selector = determineSelector(companyId, { keyId: "promoted_company_id", keySlug: "promoted_company_slug" });
  const paginationParams = determinePaginationParams(options);
  const url = readUrl("company_representations", { selector, paginationParams });
  return getResource(url);
};

export default { getAllByCompanyId, getAllByPromotedCompanyId };
